/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([

	'./NewDashboardActionHandler'
], function(BaseClass) {
	'use strict';

	var ActionHandler = BaseClass.extend({

		_getRestrictTemplate: function( /*context*/ ) {
			return 'story';
		}
	});
	return ActionHandler;
});
